// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-category-nav {
  background: white;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: 56px; /* Header高度 */
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: none; /* 默认隐藏 */
}

.mobile-category-container {
  padding: 0;
  overflow: hidden;
}

.mobile-category-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 12px 0;
  gap: 8px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* 隐藏滚动条 */
.mobile-category-scroll::-webkit-scrollbar {
  display: none;
}

.mobile-category-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid var(--color-primary);
  background: var(--color-bg-white);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-primary);
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
  min-height: 32px;
  flex-shrink: 0;
  margin-left: 12px; /* 第一个元素的左边距 */
}

.mobile-category-item:last-child {
  margin-right: 12px; /* 最后一个元素的右边距 */
}

.mobile-category-item:hover {
  background: var(--color-primary) !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.3);
}

.mobile-category-item-active {
  background: var(--color-primary) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.3);
}

.mobile-category-item-active:hover {
  background: var(--color-primary) !important;
  color: white !important;
  transform: translateY(-1px);
}



.mobile-category-text {
  font-size: 13px;
  font-weight: 500;
}

.mobile-category-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
}

/* 只在Mobile端显示 */
@media (max-width: 480px) {
  .mobile-category-nav {
    display: block;
  }
}

/* 添加渐变遮罩效果，提示可以滚动 */
.mobile-category-container::before,
.mobile-category-container::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  pointer-events: none;
  z-index: 1;
}

.mobile-category-container::before {
  left: 0;
  background: linear-gradient(to right, white, transparent);
}

.mobile-category-container::after {
  right: 0;
  background: linear-gradient(to left, white, transparent);
}

.mobile-category-container {
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/MobileCategoryNav/MobileCategoryNav.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,SAAS,EAAE,aAAa;EACxB,YAAY;EACZ,yCAAyC;EACzC,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;AAC5C;;AAEA,UAAU;AACV;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sCAAsC;EACtC,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB,EAAE,cAAc;AACnC;;AAEA;EACE,kBAAkB,EAAE,eAAe;AACrC;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,2BAA2B;AAC7B;;;;AAIA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE;IACE,cAAc;EAChB;AACF;;AAEA,oBAAoB;AACpB;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,yDAAyD;AAC3D;;AAEA;EACE,QAAQ;EACR,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".mobile-category-nav {\n  background: white;\n  border-bottom: 1px solid #e8e8e8;\n  position: sticky;\n  top: 56px; /* Header高度 */\n  z-index: 999;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  display: none; /* 默认隐藏 */\n}\n\n.mobile-category-container {\n  padding: 0;\n  overflow: hidden;\n}\n\n.mobile-category-scroll {\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 12px 0;\n  gap: 8px;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n}\n\n/* 隐藏滚动条 */\n.mobile-category-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-category-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border: 1px solid var(--color-primary);\n  background: var(--color-bg-white);\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-primary);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  white-space: nowrap;\n  min-height: 32px;\n  flex-shrink: 0;\n  margin-left: 12px; /* 第一个元素的左边距 */\n}\n\n.mobile-category-item:last-child {\n  margin-right: 12px; /* 最后一个元素的右边距 */\n}\n\n.mobile-category-item:hover {\n  background: var(--color-primary) !important;\n  color: white !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.3);\n}\n\n.mobile-category-item-active {\n  background: var(--color-primary) !important;\n  color: white !important;\n  box-shadow: 0 2px 8px rgba(108, 92, 231, 0.3);\n}\n\n.mobile-category-item-active:hover {\n  background: var(--color-primary) !important;\n  color: white !important;\n  transform: translateY(-1px);\n}\n\n\n\n.mobile-category-text {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.mobile-category-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0;\n}\n\n/* 只在Mobile端显示 */\n@media (max-width: 480px) {\n  .mobile-category-nav {\n    display: block;\n  }\n}\n\n/* 添加渐变遮罩效果，提示可以滚动 */\n.mobile-category-container::before,\n.mobile-category-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.mobile-category-container::before {\n  left: 0;\n  background: linear-gradient(to right, white, transparent);\n}\n\n.mobile-category-container::after {\n  right: 0;\n  background: linear-gradient(to left, white, transparent);\n}\n\n.mobile-category-container {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
